// extracted by mini-css-extract-plugin
export var bodySections = "_bc-8";
export var gray = "_bc-7";
export var green = "_bc-4";
export var iconContainer = "_bc-9";
export var iconWidgetContainer = "_bc-1";
export var phoneIcon = "_bc-2";
export var red = "_bc-5";
export var statusDot = "_bc-3";
export var widgetContainer = "_bc-0";
export var yellow = "_bc-6";